export type PendingDashboardBundle = {
  profile: any;
  orders: any;
  quotes: any;
};

const TTL_MS = 90_000;
let cache: { at: number; value: PendingDashboardBundle } | null = null;
let inflight: Promise<PendingDashboardBundle> | null = null;

export function tryGetCachedBundle(): PendingDashboardBundle | null {
  const now = Date.now();
  if (cache && now - cache.at < TTL_MS) {
    return cache.value;
  }
  return null;
}

export function getInflightPromise(): Promise<PendingDashboardBundle> | null {
  return inflight;
}

/** Wraps the parallel API promise: writes TTL cache on success, clears in-flight in finally. */
export function startBootstrapRequest(
  parallel: Promise<[any, any, any]>
): Promise<PendingDashboardBundle> {
  inflight = parallel.then(([profile, orders, quotes]) => {
    const value: PendingDashboardBundle = { profile, orders, quotes };
    cache = { at: Date.now(), value };
    return value;
  });
  void inflight.finally(() => {
    inflight = null;
  });
  return inflight;
}

/** Call after logout / account switch so the next session does not reuse cached bundle data. */
export function invalidatePendingDashboardBootstrapCache() {
  cache = null;
  inflight = null;
}
